import { faHandWave } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { BaseButton } from "shared/atoms/BaseButton";

import { useOnboardingNavigation } from "..";

import { IconContainer } from "./styles";

export const WelcomePage = (): JSX.Element => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { nextRoute } = useOnboardingNavigation();

  return (
    <>
      <Stack sx={{ alignItems: "center" }}>
        <IconContainer>
          <FontAwesomeIcon icon={faHandWave} fontSize="32px" />
        </IconContainer>

        <Typography variant="h2" mt="16px" mb="8px">
          {t("onboarding.1.title")}
        </Typography>
        <Typography variant="body1" color="textSecondary">
          {t("onboarding.1.body")}
        </Typography>
      </Stack>

      <BaseButton
        dataTestID="onboarding-welcome-page-next-btn"
        text={t("buttons.next")}
        onClick={() => nextRoute && navigate(nextRoute)}
        icon="arrow-right"
        iconPlacement="end"
        fullWidth
      />
    </>
  );
};
